module.exports = __webpack_public_path__ + "static/img/currentInd.63d08e01.png";